// CORE
import Vue from "vue";
import Component from "vue-class-component";

// COMPONENTS
import HomeServiceItem from "@c/Home/Services/ServiceItem/ServiceItem.vue";
import ServiceAppointComponent from "@c/Home/Services/ServiceAppoint/ServiceAppoint.vue";
import SideModal from "@c/Util/SideModal/SideModal.vue";

// ENTITIES
import ServiceEntity from "@c/Home/Services/ServiceEntity";

// INTERFACES
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";
import { SvgList, ServiceModal } from "@c/Home/Services/ServiceInterface";

// SVG ICONS
import * as iconQueries from "@/assets/icons/icon_consulta.svg";
import * as iconProcedures from "@/assets/icons/icon_briefcase-medical.svg";
import * as iconCheckUp from "@/assets/icons/icon_heartbeat.svg";
import * as iconTest from "@/assets/icons/icon_vial.svg";
import * as iconVaccines from "@/assets/icons/icon_syringe.svg";


const HomeServiceProps = Vue.extend({
  props: {
    defaultImg: {
      type: String,
      default: require('../../../assets/images/image_mulher2.webp'),
    },
  },
});
@Component({
  name: "HomeServicesComponent",
  components: {
    SideModal,
    HomeServiceItem,
    "service-appoint": ServiceAppointComponent,
  },
})

export default class HomeServicesComponent extends HomeServiceProps {
  cx_consultas = iconQueries;
  cx_procedimentos = iconProcedures;
  cx_checkUP = iconCheckUp;
  cx_teste = iconTest;
  cx_vacinas = iconVaccines;
  cx_img_woman = this.defaultImg;

  cx_svg_images!: SvgList;
  cx_servicesList!: ServiceEntity[];
  cx_selectedService!: ServiceEntity;
  cx_serviceModal!: ServiceModal;
  cx_serviceModalEmpty!: ServiceModal;

  constructor() {
    super();

    this.cx_svg_images = {} as SvgList;
    this.cx_servicesList = [] as ServiceEntity[];
    this.cx_selectedService = new ServiceEntity({} as ServiceInterface);
  }

  mounted(): void {
    this.cx_consultas = iconQueries;
    this.cx_procedimentos = iconProcedures;
    this.cx_checkUP = iconCheckUp;
    this.cx_teste = iconTest;
    this.cx_vacinas = iconVaccines;

    this.cx_svg_images = {
      consultas: "./assets/icons/icon_saude.svg?inline",
      procedimentos: "./assets/icons/icon_briefcase-medical.svg?inline",
      checkUps: "./assets/icons/icon_heartbeat.svg?inline",
      testesRapidos: "./assets/icons/icon_vial.svg?inline",
      vacinas: "./assets/icons/icon_syringe.svg?inline",
    };
  }
}
